


























































import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import {
  HsabExpenseReimbursementResponse,
  WexClaimReceiptStatus,
  HsabExpenseResponse,
  wexClaimReceiptStatusMap, HsabExpenseCategory
} from "@/shared/types";
import moment from "moment/moment";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: { Pill, CurrencyAmount }
})
export default class HsabExpenseCardRowContent extends Vue {
  hsabAccountsStore = useHsabAccountsStore();
  expenseCategoryIcon = expenseCategoryIcon;
  wexClaimReceiptStatusMap = wexClaimReceiptStatusMap;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  @Prop({ required: true })
  reimbursement: HsabExpenseReimbursementResponse;

  @Prop({ required: true })
  expenseCategory: HsabExpenseCategory;

  get formattedDate (): string {
    return moment(this.expense.dateOfService).format("MMM D, YYYY");
  }

  pillType (status: WexClaimReceiptStatus) {
    switch (status) {
      case WexClaimReceiptStatus.Complete:
        return "green-bg";
      case WexClaimReceiptStatus.ReceiptNeeded:
      case WexClaimReceiptStatus.NewReceiptNeeded:
      case WexClaimReceiptStatus.ReceiptOverdue:
        return "red-bg";
    }
    return "grey-bg";
  }

  showStatusPill (status: WexClaimReceiptStatus) {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts
        && status !== WexClaimReceiptStatus.None;
  }

  get reimbursementPlanName (): string {
    return this.expense.reimbursement ? this.expense.reimbursement.planName : "";
  }
}
